"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideUpAndRemove = exports.mutateCounter = void 0;

var mutateCounter = function mutateCounter(selector, delta) {
  var _counter$textContent;

  var counter = document.querySelector(selector);
  if (!counter) return;
  var val = Number.parseInt((_counter$textContent = counter.textContent) !== null && _counter$textContent !== void 0 ? _counter$textContent : '0', 10);
  counter.textContent = String(val + delta);
};

exports.mutateCounter = mutateCounter;

var slideUpAndRemove = function slideUpAndRemove(row) {
  var durationMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  row.style.overflow = 'hidden';
  row.style.transition = "max-height ".concat(durationMs, "ms ease, padding ").concat(durationMs, "ms ease, ") + "margin ".concat(durationMs, "ms ease");
  row.style.maxHeight = "".concat(row.scrollHeight, "px"); // Force layout flush so the start state commits before transitioning.

  var _flushLayout = row.offsetHeight;
  row.style.maxHeight = '0px';
  row.style.paddingTop = '0';
  row.style.paddingBottom = '0';
  row.style.marginTop = '0';
  row.style.marginBottom = '0';
  setTimeout(function () {
    return row.remove();
  }, durationMs);
};

exports.slideUpAndRemove = slideUpAndRemove;